module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/N-contrast-247ec92f8058a224933655baa223a6ae.svg";